import { Form, Input } from 'antd'
import { Field } from './type'
import { Rule } from 'antd/es/form'

// 正则
export const RegForm: React.FC<{ field: Field; rules: Rule[] }> = ({ field, rules }) => (
  <Form.Item rules={rules} name={[field.name, 'regex_expression']}>
    <Input.TextArea placeholder='请输入正则表达式' />
  </Form.Item>
)
